import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { LocaleContext } from './context';
import { initialLocale, LOCALE_STORAGE_KEY, type Locale } from './locale';

export function LocaleProvider({
  children,
  initial,
}: {
  children: ReactNode;
  /** Mainly for tests. */
  initial?: Locale;
}) {
  const [locale, setLocaleState] = useState<Locale>(() => initial ?? initialLocale());

  const setLocale = useCallback((next: Locale) => {
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, next);
    } catch {
      // Ignore storage failures; the choice still applies for this session.
    }
    document.documentElement.lang = next;
    setLocaleState(next);
  }, []);

  const value = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);
  return <LocaleContext value={value}>{children}</LocaleContext>;
}
